module.exports = __webpack_public_path__ + "static/img/info-ADVANTAGES-experiential-learning.8968e29.png";


//////////////////
// WEBPACK FOOTER
// ./static/info-ADVANTAGES-experiential-learning.png
// module id = /hGJ
// module chunks = 1